import {
	type VerificationGetNeighborsForResidenceData,
	verificationGetForResidence,
	verificationGetNeighborsForResidence
} from '@repo/sdk/gen'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/query/query-keys'

// The verifications name the students they are about: every fetch is recorded
// in the event log as an access (decision D37). They keep the client defaults:
// one opening of a page is one access, not one per focus.

/** One verification with the declared data and the files. */
export function verificationDetailQueryOptions(
	residenceId: string,
	verificationId: string
) {
	return queryOptions({
		queryKey: makeQueryKeys.verifications.detail(
			residenceId,
			verificationId
		),
		queryFn: async ({ signal }) =>
			(
				await verificationGetForResidence({
					body: { data: { residenceId, verificationId } },
					signal
				})
			).data
	})
}

/**
 * The verifications before and after one, in the order and with the filters
 * of the list the manager came from: only ids, so nothing is logged. Under the
 * key of the list: a write that moves the list moves them too.
 */
export function verificationNeighborsQueryOptions(
	residenceId: string,
	verificationId: string,
	filters: NonNullable<
		VerificationGetNeighborsForResidenceData['body']['filters']
	>
) {
	return queryOptions({
		queryKey: makeQueryKeys.verifications.neighbors(
			residenceId,
			verificationId,
			filters
		),
		queryFn: async ({ signal }) =>
			(
				await verificationGetNeighborsForResidence({
					body: {
						data: { residenceId, verificationId },
						filters
					},
					signal
				})
			).data
	})
}
